











































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import api from '@/api/distributor/index'
@Component({
  components: {
    CustomForm,
  },
})
export default class Withdrawal extends AbpBase {
  filters = [
    {
      label: '姓名',
      type: 'input',
      props: {
        placeholder: '请输入会员姓名',
      },
      key: 'keyWord',
    },
    {
      label: '审核状态',
      type: 'select',
      props: {
        placeholder: '请选择审核状态',
      },
      key: 'reviewStatus',
      options: [
        {
          value: 0,
          text: '待审核',
        },
        {
          value: 1,
          text: '已通过',
        },
        {
          value: 2,
          text: '已拒绝',
        },
      ],
    },
  ]
  columns = [
    {
      title: '申请时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '申请人ID',
      key: 'userId',
      align: 'center',
    },
    {
      title: '申请人名',
      key: 'nickName',
      align: 'center',
    },
    {
      title: '原上级ID',
      key: 'originalParentId',
      align: 'center',
    },
    {
      title: '原上级名',
      key: 'originalParentName',
      align: 'center',
    },
    {
      title: '申请上级ID',
      key: 'parentId',
      align: 'center',
    },
    {
      title: '申请上级名',
      key: 'parentName',
      align: 'center',
    },
    {
      title: '审核状态',
      key: 'reviewStatus',
      align: 'center',
    },
    {
      title: '审核时间',
      slot: 'checkTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  data = []
  failReason = ''
  mounted() {
    this.loadData((this.$refs.lineForm as any).form)
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  loadData(form = {}) {
    // console.log(form)
    let keyWord = form['keyWord']
    let reviewStatus = form['reviewStatus']
    api
      .getReplacementAuditList(
        this.pager.pageSize,
        this.pager.pageIndex,
        keyWord,
        reviewStatus
      )
      .then((res) => {
        console.log(res)
        this.pager.total = res.data.totalCount
        this.data = res.data.items
      })
  }
  submitChange(form, valid) {
    if (valid) {
      this.loadData(form)
    }
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  ok(id) {
    //1通过
    api.updateReviewStatus(id, 1).then((res) => {
      this.$Message.success('操作成功')
      this.loadData((this.$refs.lineForm as any).form)
    })
  }
  cancel(id) {
    //2拒绝
    this.$Modal.confirm({
      render: (h) => {
        return h('Input', {
          props: {
            value: this.failReason,
            autofocus: true,
            placeholder: '请输入不通过原因...',
          },
          on: {
            input: (val) => {
              this.failReason = val
            },
          },
        })
      },
      onOk: () => {
        api.updateReviewStatus(id, 2, this.failReason).then((res) => {
          this.$Message.success('操作成功')
          this.loadData((this.$refs.lineForm as any).form)
        })
      },
    })
  }
}
